// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 流水线命令枚举 枚举类
 * 流水线命令枚举
 */
export enum EnumPipelineCommand {
  /** 应用全流程发布 : 从开始进行全流程的发布 */
  PublishAPPFull = 1,
  /** 单一阶段执行 : 单一阶段执行 */
  SinglePhase = 2,
  /** 产品全流程发布 : 产品全流程发布 */
  PublishProductFull = 4,
  /**  :  */
  CreateDDL = 8
}

/**
 * 流水线命令枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPipelineCommandMD {
  private static items = [
    new EnumItemMD('PublishAPPFull', 1, '应用全流程发布', '从开始进行全流程的发布'),
    new EnumItemMD('SinglePhase', 2, '单一阶段执行', '单一阶段执行'),
    new EnumItemMD('PublishProductFull', 4, '产品全流程发布', '产品全流程发布'),
    new EnumItemMD('CreateDDL', 8, '', '')
  ];

  static getItem(enumItem: EnumPipelineCommand) {
    return this.items.find(item => item.name === EnumPipelineCommand[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
